/**
 * Service/CV (Veeam) Controller
 *
 * Displays information about Veeam orders
 */

// the constructor for this object
function ServiceCvController() { }

// the object
ServiceCvController.prototype = {
    constructor: ServiceCvController,
    
    // the base order id
    baseOrderId: false,
    
    // store the vm count chart object here
    vmCountChart: false,
    
    // store the storage usage stats chart object here
    storageUsageChart: false,
    
    // initialize the controller
    init: function() 
    {
        // the user must be logged in to access this page
        PortalMain.authRedirect();
        
        // register the route variables used by this controller
        this._registerRouteVariables();
        
        // register charts 
        this._registerCharts();
        
        PortalHelper.debugMessage('Service Veeam Initialized');
    },
    
    // run the controller
    run: function()
    {
        // get and populate the order
        this._getOrder();
        
        // get/populate the Veeam specific order info
        this._getCvOrder();
        
        // register the events used by this controller
        this._registerEvents();
        
        PortalHelper.debugMessage('Service Veeam Controller Ran');
    },
    
    // get the route variables and include them in the controller
    _registerRouteVariables: function() 
    {
        var segments = PortalMain.getRouteSegments();
        
        // set the base order id
        if (segments.length == 1) {
            this.baseOrderId = segments[0];
        } else {
            // the uri is missing important pieces
            PortalHelper.sendToDashboard();
        }
    },
    
    // register the javascript events
    _registerEvents:  function() 
    {   
        // bind to any of the dropdown links
        PortalHelper.hideDropdownOnClick('#range-selection-dropdown');
        $('#range-selection-dropdown ul li a').on('click', function(){
            PortalMain.ServiceCvController._updateChartRange(
                this.dataset.timelineRangeSeconds
            );
            
            PortalMain.ServiceCvController._updateSelectedRange(this);
        });
        
        // download the csv file of the clients clicked
        $('.download-clients').on('click', function(e) {
            e.preventDefault();
            
            PortalMain.ServiceCvController._downloadClients();
        });
    },
    
    // register the chart
    _registerCharts: function()
    {
        // new chart for client count history
        var vmCountChart = new PortalChart;
        vmCountChart.elementId = 'vm-count-chart';
        vmCountChart.type = 'line';
        vmCountChart.dataFormat = 'number';
        vmCountChart.columns = [];
        this.vmCountChart = vmCountChart;
        
        // new chart for protected stats history
        var storageUsageChart = new PortalChart;
        storageUsageChart.elementId = 'storage-usage-chart';
        storageUsageChart.type = 'line';
        storageUsageChart.dataFormat = 'bytes';
        storageUsageChart.columns = [];
        this.storageUsageChart = storageUsageChart;
    },
    
    // get the orders from the api
    _getOrder: function()
    {
        PortalMain.ServiceIndexController = new ServiceIndexController;
        
        PortalMain.ServiceIndexController.baseOrderId = this.baseOrderId;
        
        PortalMain.ServiceIndexController._getOrder();
    },
    
    // get veeam specific order info (usage information)
    _getCvOrder: function()
    {
        var cvOrderRequest = new PortalRequest;
        cvOrderRequest.errorElement = '.order-fail';
        cvOrderRequest.makeRequest(
            '/orders-cv/get-order-cv',
            {
                baseOrderId: this.baseOrderId,
            },
            function(data) {
                // fill in the stats section
                PortalMain.ServiceCvController._populateCvOrderStats(data);
                
                // get the orders stats
                PortalMain.ServiceCvController._getCvStats();

                // get order rates
                PortalMain.ServiceCvController._populateCvOrderRates(data);
                
            },
            function() {
                // no cv order found, so hide the content
                $('#cv-content').addClass('hidden');
            }
        )
    },
    
    // populate document with usage information
    _populateCvOrderStats: function(cvInfo)
    {
        
        // set the client count
        $('#vm-count').text(cvInfo.backup_count);
        
        // set the storage usage
        var usedBytes = cvInfo.used_bytes;
        
        usedBytes = PortalHelper.formatBytes(usedBytes);
        $('#storage-usage span:nth-child(1)').text(usedBytes[0]);
        $('#storage-usage span:nth-child(2)').text(usedBytes[1]);
        
        // set the storage rate
        var usageRate = cvInfo.per_gb_rate;
        usageRate = PortalHelper.numberToDollars(usageRate, 2, true);
        $('#usage-rate').text(usageRate);
        
        // set the client total
        var storageTotal = cvInfo.gb_amount;
        storageTotal = PortalHelper.numberToDollars(storageTotal);
        $('#storage-total').text(storageTotal);
        
        // set the date
        var date = PortalHelper.formatDate(cvInfo.run_date);
        $('#cv-stats .date').text(date);
        
        PortalHelper.loadingOverlay('#cv-stats', false);
        
        
    },
    
    // retrieves the timeline veeam stats
    _getCvStats: function(startDate, endDate)
    {
        // defaulting to 1 week range if a start or end date not passed
        if(!(startDate instanceof Date) || !(endDate instanceof Date)) {
            var startDate = new Date();
            var endDate = new Date();
            
            startDate.setMonth(
                startDate.getMonth() - 1
            );
        }
        
        var cvStatsRequest = new PortalRequest;
        cvStatsRequest.makeRequest(
            '/orders-cv/get-cv-stats',
            {
                baseOrderId: this.baseOrderId,
                // Date() strikes again. Dividing by 1000 here to get seconds instead of ms
                startDate: startDate.getTime() / 1000|0,
                endDate: endDate.getTime() / 1000|0,
            },
            function(data) {
                
                if (data.length > 1) {
                    PortalMain.ServiceCvController._populateVmCountChart(data, startDate, endDate);
                    PortalMain.ServiceCvController._populateStorageUsageChart(data, startDate, endDate);
                }
            }
        );
    },
    
    // sets up the vm count graph, populating columns and data
    _populateVmCountChart: function(chartData, startDate, endDate)
    {
        // keep only the specified columns for the chart
        chartData = PortalHelper.chartGetColumns(chartData, [
            'Time',
            'VMs'
        ]);
        
        this.vmCountChart.minDate = startDate;
        this.vmCountChart.maxDate = endDate;
        // resetting columns first
        this.vmCountChart.columns = [];
        for(var i in chartData[0]) {
            var currentField = chartData[0][i];
            if(currentField == 'Time') {
                this.vmCountChart.columns[i] = ['date', currentField];
            } else {
                this.vmCountChart.columns[i] = ['number', currentField];
            }
        }
        
        if(chartData.length == 1) {
            $('#vm-count-chart').text("No data available for this period.");
        } else {
            this.vmCountChart.data = chartData;
            this.vmCountChart.draw();
        }
        PortalHelper.loadingOverlay('#vm-count-chart', false);        
    },
    
    // fill in and display the per GB rate
    _populateCvOrderRates: function(cvInfo)
    {
        // set the per gb rate
        var perGbRate = $('#usage-rates .clone-source').clone();
        perGbRate.removeClass('clone-source');

        $('.rate-label', perGbRate).text('Per GB Rate');

        var rate = cvInfo.per_gb_rate;
        rate = PortalHelper.numberToDollars(rate, 2, true);
        $('.rate-amount', perGbRate).text(rate);

        $('#usage-rates').append(perGbRate);

        // set the per vm rate
        if (cvInfo.per_vm_rate != undefined) {
            var bsBmRate = $('#usage-rates .clone-source').clone();
            bsBmRate.removeClass('clone-source');

            $('.rate-label', bsBmRate).text('Rate Per VM');

            var rate = cvInfo.per_vm_rate;
            rate = PortalHelper.numberToDollars(rate, 2, true);
            $('.rate-amount', bsBmRate).text(rate);

            $('#usage-rates').append(bsBmRate);
        }

        // set the per vm rate
        if (cvInfo.mm_rate_per_vm != undefined) {
            var bsBmRate = $('#usage-rates .clone-source').clone();
            bsBmRate.removeClass('clone-source');

            $('.rate-label', bsBmRate).text('Management Rate Per VM');

            var rate = cvInfo.mm_rate_per_vm;
            rate = PortalHelper.numberToDollars(rate, 2, true);
            $('.rate-amount', bsBmRate).text(rate);

            $('#usage-rates').append(bsBmRate);
        }

        // show the usage rates
        $('#usage-rates').removeClass('hidden');
    },

    // sets up the storage usage graph, populating columns and data
    _populateStorageUsageChart: function(chartData, startDate, endDate)
    {
        // keep only the specified columns for the chart
        chartData = PortalHelper.chartGetColumns(chartData, [
            'Time',
            'Storage'
        ]);
        
        this.storageUsageChart.minDate = startDate;
        this.storageUsageChart.maxDate = endDate;
        // resetting columns first
        this.storageUsageChart.columns = [];
        for(var i in chartData[0]) {
            var currentField = chartData[0][i];
            if(currentField == 'Time') {
                this.storageUsageChart.columns[i] = ['date', currentField];
            } else {
                this.storageUsageChart.columns[i] = ['number', currentField];
            }
        }
        
        if(chartData.length == 1) {
            $('#storage-usage-chart').text("No data available for this period.");
        } else {
            this.storageUsageChart.data = chartData;
            this.storageUsageChart.draw();
        }
        PortalHelper.loadingOverlay('#storage-usage-chart', false);        
    },
    
    // changes what date range is displayed
    _updateChartRange: function(dateRangeSeconds)
    {
        PortalHelper.loadingOverlay('#vm-count-chart', true);
        PortalHelper.loadingOverlay('#storage-usage-chart', true);
        var endDate = new Date();
        var startDate = new Date(
            endDate.getTime() 
            - (dateRangeSeconds * 1000)
        );
        
        this._getCvStats(startDate, endDate);
    },
    
    // adds interactivity to the dropdown range selection
    _updateSelectedRange: function(element)
    {
        var selectedElementText = $(element).text();
        $('.selection-text').text(selectedElementText);
    },
}